const categoryStatus = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'SUSPENDED', name: 'Suspended' }
];

const automatedNotificationsOptions = [
  { id: '0', name: 'No automated notifications' },
  { id: '1', name: 'To regular contacts only' },
  { id: '2', name: 'To admin users only' },
  { id: '3', name: 'To regular contacts and admin users' }
];

export { categoryStatus, automatedNotificationsOptions };
